import {parsePhoneNumber} from 'libphonenumber-js'

const phoneHandler = {
  validate(phone) {
    try {
      const phoneNumber = parsePhoneNumber(phone, 'SE')

      return phoneNumber.isValid() && phoneNumber.country === 'SE'
    } catch (error) {
      return false
    }
  },
  formatNational(phone) {
    try {
      const phoneNumber = parsePhoneNumber(phone, 'SE')

      return phoneNumber.formatNational()
    } catch (error) {
      return phone
    }
  },
  formatE164(phone) {
    try {
      const phoneNumber = parsePhoneNumber(phone, 'SE')

      return phoneNumber.format('E.164')
    } catch (error) {
      return phone
    }
  }
}

export default phoneHandler



// WEBPACK FOOTER //
// ./resources/assets/js/app/services/PhoneHandler.js